import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Mic, History, Users, BookHeart, AudioLines, Map } from "lucide-react";
import { SERVICES, IMAGES } from "../data/content";
import { FinalCTA } from "./Home";

const ICONS = {
  "Talking Trails Development": Map,
  "Oral History Recording": Mic,
  "Cultural Interpretation": Users,
  "Heritage Storytelling": History,
  "Audio Production": AudioLines,
  "Tourism Experience Design": BookHeart,
};

export default function Services() {
  return (
    <div data-testid="page-services">
      <section className="relative pt-40 pb-20 md:pt-52 md:pb-28 bg-brand-ink text-brand-cream overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center opacity-40"
          style={{ backgroundImage: `url(${IMAGES.river})` }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-brand-ink/60 to-brand-ink/95" />
        <div className="container-px relative z-10">
          <div className="overline text-brand-ochre">Services</div>
          <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl mt-5 leading-[1.04] max-w-4xl">
            Transforming places <span className="italic font-light">into living experiences.</span>
          </h1>
          <p className="mt-6 text-brand-cream/85 text-lg font-light max-w-3xl leading-relaxed">
            Through audio storytelling, interpretive signage and digital experiences that
            connect people to place. From oral history capture to tourism experience
            design, every project begins with listening — to people, to place, to Country.
          </p>
        </div>
      </section>

      <section className="py-20 md:py-28">
        <div className="container-px">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-brand-line">
            {SERVICES.map((s, i) => {
              const Icon = ICONS[s.title] || Map;
              return (
                <article
                  key={s.title}
                  data-testid={`service-card-${i + 1}`}
                  className="bg-brand-cream p-10 md:p-14 group relative"
                >
                  <div className="flex items-start justify-between">
                    <div className="overline">0{i + 1}</div>
                    <Icon size={22} className="text-brand-ochre" />
                  </div>
                  <h3 className="font-serif text-3xl md:text-4xl mt-8 text-brand-charcoal leading-tight">
                    {s.title}
                  </h3>
                  <p className="mt-5 text-brand-muted leading-relaxed font-light">{s.desc}</p>
                  <Link
                    to="/contact"
                    className="mt-8 inline-flex items-center gap-2 text-xs uppercase tracking-[0.22em] text-brand-ochre hover:text-brand-rainforest transition-colors"
                  >
                    Discuss this service <ArrowRight size={14} />
                  </Link>
                  <div className="absolute bottom-0 left-0 h-px w-0 bg-brand-ochre group-hover:w-full transition-all duration-700" />
                </article>
              );
            })}
          </div>
        </div>
      </section>

      {/* CTA STRIP */}
      <section className="py-16 md:py-24 bg-brand-sand">
        <div className="container-px grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
          <div className="lg:col-span-7">
            <h2 className="font-serif text-3xl md:text-4xl text-brand-charcoal leading-tight">
              Not sure where to start? <span className="italic font-light">We will help you find the story.</span>
            </h2>
          </div>
          <div className="lg:col-span-5 flex flex-col sm:flex-row gap-4 lg:justify-end">
            <Link
              to="/contact"
              data-testid="services-cta-contact"
              className="inline-flex items-center justify-center gap-2 bg-brand-rainforest text-brand-cream px-7 py-3.5 text-xs uppercase tracking-[0.22em] hover:bg-brand-rainforestDark transition-colors"
            >
              Start a Conversation <ArrowRight size={14} />
            </Link>
            <Link
              to="/featured-trails"
              className="inline-flex items-center justify-center gap-2 border border-brand-charcoal/40 text-brand-charcoal px-7 py-3.5 text-xs uppercase tracking-[0.22em] hover:bg-brand-charcoal hover:text-brand-cream transition-colors"
            >
              View Featured Trails
            </Link>
          </div>
        </div>
      </section>

      <FinalCTA />
    </div>
  );
}
